module.exports = __webpack_public_path__ + "img/y_p2_zhengwu.28659136.svg";